import React from 'react';
import LOOKUP from 'constants/lookup';
import { mapPo } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';

const POHistory = ({ po, pagination, changePage }) => {
    const compName = "po";
    return (
        <div className="product-content list-table">
            <CardSimple>
                <GenericTable
                    className="table_center"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    stripedRows={true}
                    columns={LOOKUP.purchaseOrder.productPurchaseOrderColumns}
                    rows={mapPo(po.list)}
                />
                <Pagination
                    length={po.total}
                    itemsPerPage={pagination.itemsPerPage}
                    activePage={pagination.activePage}
                    onPageChange={(e) => changePage(e, compName)}
                />
            </CardSimple>
        </div>
    )
}

export default POHistory;